<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('modifRemiseBancaire.informations.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field :label="$t('editLotPaiement.informations.libelle')"
                 class="column is-3">
          <b-input v-model="remiseBancaire.nom">
          </b-input>
        </b-field>
        <b-field :label="$t('modifRemiseBancaire.informations.dateRemise')"
                 class="obligatoire column is-3">
          <div class="column is-12 is-paddingless">
            <div class="columns">
              <b-tooltip class="width-100percent"
                :label="errorsExercice"
                multiline
                type="is-warning"
                position="is-left"
                v-if="!exerciceOk">
                <b-icon icon="alert" custom-size="mdi-24px" type="is-warning"
                  class="column is-1"
                  v-if="!exerciceOk"></b-icon>
              </b-tooltip>
              <b-datepicker show-week-number
                  icon="calendar-today"
                  @input="dateChanged"
                  v-model="remiseBancaire.dateRemise"
                  class="column"
                  :class="exerciceOk?'is-12':'is-11'"
                  :editable="true"
                  nearby-selectable-month-days>
              </b-datepicker>
            </div>
          </div>
        </b-field>
        <b-field :label="$t('modifRemiseBancaire.informations.banque')"
                 class="obligatoire column is-3">
          <b-select v-model="remiseBancaire.domiciliationBancaireId" expanded>
            <option v-for="domiciliationBancaire in domiciliationsBancaire"
                    :value="domiciliationBancaire.id" :key="domiciliationBancaire.id">
              {{domiciliationBancaire.libelleBanque}} ({{ domiciliationBancaire.libelle }})
            </option>
          </b-select>
        </b-field>
        <b-field :label="$t('modifRemiseBancaire.informations.modeReglement')"
                 class="obligatoire column is-3">
          <b-select v-model="remiseBancaire.modeReglementId" expanded>
            <option v-for="modeReglement in modesReglement"
                    :value="modeReglement.id" :key="modeReglement.id">
              {{ modeReglement.libelle }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import debounce from 'lodash/debounce';
import { checkExercice } from '@/api/compta/exerciceComptable/index';
import validationEcriture from '@/services/ecritureComptable/validation';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    remiseBancaire: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      exerciceOk: true,
      errorsExercice: '',
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    domiciliationsBancaire() {
      return this.parametre(PARAMETRES_KEYS.domiciliationBancaire)
        .filter((domicialisation) => { return domicialisation.actif; });
    },
    modesReglement() {
      return this.parametre(PARAMETRES_KEYS.modeReglement);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    dateChanged: debounce(async function dateDealer() {
      await checkExercice(this.remiseBancaire.societeId, this.remiseBancaire.dateRemise)
        .then(response => {
          this.exerciceOk = response.data.result.state;
          if (response.data.result.errors !== null && response.data.result.errors.length >= 1) {
            const messages = [];
            validationEcriture(this.$i18n, response.data.result.errors, messages);
            this.errorsExercice = this.$i18n.t(messages[0].message, messages[0].parametres);
          }
        });
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.loadParametres([
        PARAMETRES_KEYS.domiciliationBancaire,
        PARAMETRES_KEYS.modeReglement,
      ]);
      await checkExercice(this.remiseBancaire.societeId, this.remiseBancaire.dateRemise)
        .then(response => {
          this.exerciceOk = response.data.result.state;
          if (response.data.result.errors !== null && response.data.result.errors.length >= 1) {
            const messages = [];
            validationEcriture(this.$i18n, response.data.result.errors, messages);
            this.errorsExercice = this.$i18n.t(messages[0].message, messages[0].parametres);
          }
        });
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
